<template>
    <div class="handContainer">
        <div v-if="!me || me.card == null" class="pick-hint">
            <i class="fa fa-arrow-down bounce-arrow"></i>
            <span>Pick your card</span>
        </div>
        <div class="hand-actions">
            <button class="action-btn" @click="pickUp" title="Pick up your card">
                <i class="fa fa-hand-paper-o"></i> Pick up
            </button>
            <button class="action-btn" @click="flipCard" title="Show/hide your card">
                <i class="fa fa-eye"></i>
                {{ me && me.hidden ? 'Show' : 'Hide' }}
            </button>
            <button class="action-btn action-btn--primary" @click="flipAll" title="Reveal all cards">
                <i class="fa fa-users"></i> Reveal all
            </button>
            <button class="action-btn action-btn--danger" @click="clearTable" title="Reset for next round">
                <i class="fa fa-refresh"></i> New round
            </button>
        </div>
        <div class="hand-cards">
            <div v-for="(card, index) in $store.getters.deck"
                v-bind:key="index"
                :class="['mini-card', { 'mini-card--selected': me && index === me.card }]"
                @click="pickCard(index)"
            >
                <span class="mini-card__value">{{ card }}</span>
            </div>
        </div>
    </div>
</template>
<script lang='ts'>
import Vue from 'vue'

export default Vue.extend({
    name: 'Hand',
    props: {
        autoReveal: { type: Boolean, default: false }
    },
    computed: {
        me() {
            return this.$store.getters.members
                .find(mem => mem.id == this.$socket.id)
        },
    },
    methods: {
        pickCard(index: number) {
            this.$socket.emit('pickCard', index)
        },
        pickUp() {
            this.$socket.emit('pickCard', null)
        },
        flipCard() {
            this.$socket.emit('flipCard')
        },
        flipAll() {
            this.$socket.emit('flipAll')
        },
        clearTable() {
            this.$socket.emit('clearTable')
        },
    }
})
</script>
<style scoped>
.handContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px 24px 18px;
    background: var(--panel-bg);
    border-top: 1px solid var(--border-color);
    flex-shrink: 0;
    box-shadow: 0 -2px 12px var(--shadow-sm, rgba(0,0,0,0.04));
}

.hand-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.action-btn {
    padding: 8px 16px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-secondary);
    border-radius: 10px;
    cursor: pointer;
    font-size: 0.8em;
    font-weight: 500;
    transition: all 0.2s;
    box-shadow: var(--shadow-sm);
}

.action-btn:hover {
    background: var(--card-hover);
    color: var(--text-primary);
    transform: translateY(-1px);
    box-shadow: var(--shadow-md);
}

.action-btn--primary {
    background: var(--success-subtle);
    border-color: var(--success);
    color: var(--success);
}

.action-btn--primary:hover {
    box-shadow: 0 4px 12px var(--success-subtle);
}

.action-btn--danger {
    background: var(--danger-subtle);
    border-color: var(--danger);
    color: var(--danger);
}

.action-btn--danger:hover {
    box-shadow: 0 4px 12px var(--danger-subtle);
}

.hand-cards {
    display: flex;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 8px 0 4px;
    overflow-x: auto;
}

.mini-card {
    width: 56px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: var(--card-bg);
    border: 1.5px solid var(--border-color);
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    flex-shrink: 0;
    box-shadow: var(--shadow-card);
}

.mini-card:hover {
    transform: translateY(-5px);
    background: var(--card-hover);
    border-color: var(--accent);
    box-shadow: var(--shadow-md), 0 4px 12px var(--accent-glow);
}

.mini-card--selected {
    background: var(--accent-subtle);
    border-color: var(--accent);
    transform: translateY(-7px);
    box-shadow: var(--shadow-md), 0 6px 20px var(--accent-glow);
}

.mini-card--selected .mini-card__value {
    color: var(--accent);
}

.mini-card__value {
    font-size: 1.1em;
    font-weight: 800;
    color: var(--text-primary);
}

/* Pick hint arrow */
.pick-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: var(--accent);
    font-size: 0.78em;
    font-weight: 600;
    padding-bottom: 2px;
}

.bounce-arrow {
    animation: bounceDown 1.2s ease-in-out infinite;
    font-size: 1.2em;
}

@keyframes bounceDown {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(5px); }
}
</style>